{
  "net": "Neto",
  "gross": "Bruto",
  "Mo": "Meses",
  "years": "Años",
  "first-payment-date": "Primera fecha de pago",
  "last-payment-date": "Última Fecha de Pago",
  "mortgage-commitment-date": "Fecha de compromiso hipotecario",
  "late-penalty": "Penalización tardía",
  "case-inst-mortgage": "Caso Ins. Hipotecaria",
  "grace-period-days": "Días del período de gracia",
  "interest-rate": "Tasa de interés",
  "interest": "Interés",
  "fixed": "Fijo",
  "variable": "Variable",
  "loan": "Préstamo",
  "heloc": "HELOC",
  "heloc_initial_draw": "Desembolso inicial",
  "construction_loan": "Préstamo para construcción",
  "construction_loan_initial_loan": "Préstamo inicial",
  "mers": "MERS",
  "mers_min": "Min",
  "loan_type": "Tipo de préstamo",
  "margin": "Margen",
  "fee": "Tarifa",
  "period-start": "Periodo de Inicio",
  "period-end": "Periodo de termino",
  "loans": "Préstamos",
  "delete-loan": "Eliminar Préstamo",
  "related-amounts": "Montos relacionados",
  "amount-kind": "Tipo de monto",
  "loan-amount": "Monto del préstamo",
  "purpose": "Propósito",
  "product": "Producto",
  "buyer-issue-date": "Fecha de emisión del CD del comprador",
  "seller-issue-date": "Fecha de emisión del CD del vendedor",
  "days-passed": "Días transcurridos para ser cargado con una tarifa por pago atrasado",
  "not-additional": "No hay adicionales aún",
  "additional": "Adicional",
  "add-additional": "Agregar Adicional",
  "late-penalty-as": "Penalización por atraso como",
  "not-interests": "No hay intereses aún",
  "add-interests": "Agregar Intereses",
  "days_per_year": "Días por año",
  "conventionalInsured": "Convencional Asegurado",
  "conventionalUninsured": "Convencional No Asegurado",
  "rhs": "RHS",
  "fha": "FHA",
  "va": "VA",
  "purchase": "Compra",
  "refinance": "Refinanciamiento",
  "homeEqualityLoan": "Préstamo sobre el valor de la vivienda",
  "construction": "Construcción",
  "deleteInterestTitle": "Eliminar Interés",
  "deleteInterestConfirmation": "¿Está seguro de que desea eliminar el interés?",
  "deleteAdditionalTitle": "Eliminar Adicional",
  "deleteAdditionalConfirmation": "¿Está seguro de que desea eliminar el adicional?",
  "deleteLoanConfirmation": "¿Está seguro de que desea eliminar el préstamo?",
  "increases": "Aumentos",
  "disclosures": "Divulgaciones",
  "noLoansYet": "Esta orden aún no tiene préstamos",
  "escrowAmounts": "Montos de Depósito en Garantía",
  "lendingTo": "prestando a",
  "createLoanInterest": "Crear Interés de Préstamo",
  "createLoan": "Agregar Préstamo",
  "loan-unknown": "Préstamo #(desconocido)",
  "loan-created": "Préstamo creado correctamente",
  "lenders": "Prestamistas",
  "add-lender": "Agregar prestamista",
  "add-lender-title": "Agregar un prestamista a esta orden",
  "add-lender-text": "Busca un contacto y agrégalo como prestamista.",
  "no-lenders-alert": "Esta orden aún no tiene prestamistas. Agrega uno para completar los detalles del préstamo.",
  "remove-lender": "Quitar prestamista",
  "lender-already-added": "Este contacto ya es prestamista de esta orden."
}
